import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getBeverlyHillsStructuredData() {
  const url = "https://restorehair.com/locations/california/beverly-hills/";
  const description =
    "Find out about your hair transplant options in Beverly Hills with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("beverly-hills", url, description),
    locationPageCrumbs(url, "Beverly Hills"),
  ];
}
